import { Injectable, inject } from '@angular/core';
import { WINDOW_REF } from '@core/tokens/window-ref-injection-token.const';
import { BehaviorSubject } from 'rxjs';
import { CookieInformation } from './model/cookie-information.interface';
import { COOKIE_KEYS } from './model/cookie-keys.const';

@Injectable({
  providedIn: 'root',
})
export class CookiePolicyService {
  private windowRef = inject<Window & { CookieInformation: CookieInformation }>(WINDOW_REF);

  public consentGiven = new BehaviorSubject<boolean>(false);

  init() {
    if (!this.windowRef.location.hostname.includes('localhost')) {
      const script = document.createElement('script');
      script.src = 'https://policy.app.cookieinformation.com/uc.js';
      script.setAttribute('data-culture', 'DA');
      script.type = 'text/javascript';
      script.id = 'CookieConsent';
      document.head.appendChild(script);

      this.windowRef.addEventListener(
        'CookieInformationConsentGiven',
        () => {
          const consentGiven = this.windowRef.CookieInformation.getConsentGivenFor(COOKIE_KEYS.cookie_cat_statistic);
          this.consentGiven.next(consentGiven);
        },
        false
      );
    }
  }
}
